import { Modal as CXModal } from '@sanlamcx/react-ui-next-modal';

type Modal = typeof CXModal;

export const Modal: Modal = CXModal;
